import { render, staticRenderFns } from "./AddBoxQuantity.vue?vue&type=template&id=f520a3a0&scoped=true"
import script from "./AddBoxQuantity.vue?vue&type=script&lang=js"
export * from "./AddBoxQuantity.vue?vue&type=script&lang=js"
import style0 from "./AddBoxQuantity.vue?vue&type=style&index=0&id=f520a3a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f520a3a0",
  null
  
)

export default component.exports